import { Switch } from '@headlessui/react';
import { IResourcePermission } from '@gettactic/api';
import { classNames } from '@/lib/classNames';

type Props = {
  permission: IResourcePermission;
  onChange: (x: IResourcePermission) => void;
};

export function ApprovableCell({ permission, onChange }: Props) {
  const value = permission.is_approvable;

  return (
    <Switch.Group as="div" className="my-2">
      <Switch
        onChange={() => {
          onChange(permission);
        }}
        checked={!!value}
        className={classNames(
          value ? 'bg-primary' : 'bg-gray-200',
          'relative col-span-2 ml-4 inline-flex h-6 w-11 shrink-0 cursor-pointer justify-self-end rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            value ? 'translate-x-5' : 'translate-x-0',
            'inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
          )}
        />
      </Switch>
    </Switch.Group>
  );
}
